"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createConfig_exports = {};
__export(createConfig_exports, {
  default: () => createConfig
});
module.exports = __toCommonJS(createConfig_exports);
var import_createAxiosConfig = __toESM(require("./createAxiosConfig"), 1);
var import_createBuildConfig = __toESM(require("./createBuildConfig"), 1);
var import_createBuildModulesConfig = __toESM(require("./createBuildModulesConfig"), 1);
var import_createComponentsConfig = __toESM(require("./createComponentsConfig"), 1);
var import_createCSSConfig = __toESM(require("./createCSSConfig"), 1);
var import_createGSAPConfig = __toESM(require("./createGSAPConfig"), 1);
var import_createGTMConfig = __toESM(require("./createGTMConfig"), 1);
var import_createHeadConfig = __toESM(require("./createHeadConfig"), 1);
var import_createI18nConfig = __toESM(require("./createI18nConfig"), 1);
var import_createModulesConfig = __toESM(require("./createModulesConfig"), 1);
var import_createPluginsConfig = __toESM(require("./createPluginsConfig"), 1);
var import_createProxyConfig = __toESM(require("./createProxyConfig"), 1);
var import_createPublicRuntimeConfig = __toESM(require("./createPublicRuntimeConfig"), 1);
var import_createServerConfig = __toESM(require("./createServerConfig"), 1);
var import_createStorybookConfig = __toESM(require("./createStorybookConfig"), 1);
var import_createVueConfig = __toESM(require("./createVueConfig"), 1);
function createConfig(options) {
  const {
    title,
    theme,
    trailingSlashRedirect = true,
    styles = ["~/assets/css/tailwind.css", "~/assets/scss/index.scss"]
  } = options;
  return {
    head: (0, import_createHeadConfig.default)({ title }),
    css: (0, import_createCSSConfig.default)({ styles }),
    plugins: (0, import_createPluginsConfig.default)({ trailingSlashRedirect }),
    components: (0, import_createComponentsConfig.default)(),
    buildModules: (0, import_createBuildModulesConfig.default)(),
    modules: (0, import_createModulesConfig.default)(),
    server: (0, import_createServerConfig.default)(),
    axios: (0, import_createAxiosConfig.default)(),
    proxy: (0, import_createProxyConfig.default)(),
    gtm: (0, import_createGTMConfig.default)(),
    i18n: (0, import_createI18nConfig.default)(),
    gsap: (0, import_createGSAPConfig.default)(),
    vue: (0, import_createVueConfig.default)(),
    build: (0, import_createBuildConfig.default)(),
    publicRuntimeConfig: (0, import_createPublicRuntimeConfig.default)(),
    storybook: (0, import_createStorybookConfig.default)({ title, storybookTheme: theme })
  };
}
;
